/* ============================================================
   MOTHER'S DAY 2026 — Wishes: marquee + footer block
   ============================================================ */
(function () {
  'use strict';

  var WISHES = [
    'Дякую, мамо', 'Я тебе люблю', 'Найкращій у світі', 'Мамо, ти моє все',
    'Дякую за тепло', 'З Днем матері', 'Найніжніша', 'Мамо моя',
    'З любов\u0027ю', 'Дякую, що поруч', 'Найдорожча', 'Мамо, обіймаю',
    'Ти моя сила', 'Дякую за все', 'Мамусю', 'Найрідніша',
    'Зі святом, мамо', 'Ти найкраща', 'Завжди в серці', 'Мамо, дякую',
    'Ти моє сонце', 'Люблю всім серцем', 'Найтепліша', 'Цілую міцно'
  ];

  var ORNAMENTS = ['✿', '❀', '✾', '❁', '·'];
  var FONTS = ['Caveat', 'Kalam', 'Marck Script'];
  var COLORS = [
    '#e0879e', '#c4787a', '#b06888', '#6a9a72',
    '#5a7a9a', '#a8705a', '#c87a8a', '#8a70a8',
    '#b89860', '#5a9a88'
  ];

  function pick(arr) { return arr[Math.floor(Math.random() * arr.length)]; }

  // ─── Marquee (біжучий рядок під хедером) ───────────────────
  function createMarquee() {
    var bar = document.createElement('div');
    bar.className = 'mama-marquee';
    bar.setAttribute('aria-hidden', 'true');

    var track = document.createElement('div');
    track.className = 'mama-marquee__track';

    // Дублюємо контент для безшовного циклу
    for (var copy = 0; copy < 3; copy++) {
      WISHES.forEach(function (text, i) {
        var span = document.createElement('span');
        span.className = 'mama-marquee__item';
        var font = FONTS[i % FONTS.length];
        var color = COLORS[i % COLORS.length];
        span.style.fontFamily = '"' + font + '", cursive';
        span.style.color = color;
        span.textContent = text;
        track.appendChild(span);

        // Орнамент-розділювач
        var sep = document.createElement('span');
        sep.className = 'mama-marquee__sep';
        sep.textContent = ORNAMENTS[i % ORNAMENTS.length];
        sep.style.color = COLORS[(i + 3) % COLORS.length];
        track.appendChild(sep);
      });
    }

    bar.appendChild(track);

    // Вставляємо після хедера
    var header = document.querySelector('header, .shopify-section-group-group-header, #shopify-section-header');
    if (header && header.nextSibling) {
      header.parentNode.insertBefore(bar, header.nextSibling);
    } else {
      document.body.insertBefore(bar, document.body.firstChild);
    }
  }

  // ─── Footer block (статичний) ──────────────────────────────
  function createFooterBlock() {
    var block = document.createElement('div');
    block.className = 'mama-footer-wishes';
    block.setAttribute('aria-hidden', 'true');

    // Обираємо 5 побажань для футера
    var selected = [];
    var used = {};
    while (selected.length < 5) {
      var w = pick(WISHES);
      if (!used[w]) { selected.push(w); used[w] = true; }
    }

    var inner = document.createElement('div');
    inner.className = 'mama-footer-wishes__inner';

    selected.forEach(function (text, i) {
      var span = document.createElement('span');
      span.className = 'mama-footer-wishes__item';
      span.style.fontFamily = '"' + FONTS[i % FONTS.length] + '", cursive';
      span.style.color = COLORS[i % COLORS.length];
      span.textContent = text;
      inner.appendChild(span);

      if (i < selected.length - 1) {
        var sep = document.createElement('span');
        sep.className = 'mama-footer-wishes__sep';
        sep.textContent = pick(ORNAMENTS);
        sep.style.color = COLORS[(i + 5) % COLORS.length];
        inner.appendChild(sep);
      }
    });

    block.appendChild(inner);

    var footer = document.querySelector('.shopify-section-group-group-footer, footer, .site-footer-wrapper');
    if (footer) {
      footer.parentNode.insertBefore(block, footer);
    } else {
      document.body.appendChild(block);
    }
  }

  // ─── CSS ───────────────────────────────────────────────────
  var css = document.createElement('style');
  css.textContent =
    /* Marquee */
    '.mama-marquee{' +
      'overflow:hidden;white-space:nowrap;' +
      'background:#fdf6f8;' +
      'border-bottom:1px solid rgba(240,142,180,0.15);' +
      'padding:10px 0;' +
      'position:relative;z-index:10;' +
    '}' +
    '.mama-marquee__track{' +
      'display:inline-flex;align-items:center;' +
      'animation:mamaMarquee 60s linear infinite;' +
    '}' +
    '.mama-marquee__item{' +
      'font-size:18px;font-weight:500;' +
      'padding:0 8px;flex-shrink:0;' +
    '}' +
    '.mama-marquee__sep{' +
      'font-size:14px;opacity:0.5;padding:0 12px;flex-shrink:0;' +
    '}' +
    '@keyframes mamaMarquee{' +
      '0%{transform:translateX(0)}' +
      '100%{transform:translateX(-33.333%)}' +
    '}' +

    /* Footer block */
    '.mama-footer-wishes{' +
      'text-align:center;' +
      'padding:28px 20px;' +
      'background:#fdf6f8;' +
      'border-top:1px solid rgba(240,142,180,0.15);' +
    '}' +
    '.mama-footer-wishes__inner{' +
      'display:flex;align-items:center;justify-content:center;' +
      'flex-wrap:wrap;gap:6px;' +
    '}' +
    '.mama-footer-wishes__item{' +
      'font-size:20px;font-weight:500;padding:0 4px;' +
    '}' +
    '.mama-footer-wishes__sep{' +
      'font-size:14px;opacity:0.4;padding:0 8px;' +
    '}' +

    /* Mobile */
    '@media(max-width:480px){' +
      '.mama-marquee__item{font-size:15px}' +
      '.mama-footer-wishes__item{font-size:17px}' +
      '.mama-footer-wishes{padding:20px 16px}' +
    '}' +

    /* Reduced motion */
    '@media(prefers-reduced-motion:reduce){' +
      '.mama-marquee__track{animation:none}' +
    '}' +

    /* Print */
    '@media print{.mama-marquee,.mama-footer-wishes{display:none!important}}';

  document.head.appendChild(css);

  // ─── Init ──────────────────────────────────────────────────
  function init() {
    createMarquee();
    createFooterBlock();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
